"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
exports.__esModule = true;
exports.phoneNumberFormatValue = exports.getCountryFromPhone = exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _lodash = require("lodash");
var _postalCodesJs = _interopRequireDefault(require("postal-codes-js"));
var _libphonenumberJs = _interopRequireWildcard(require("libphonenumber-js"));
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}

/**
 * minLength Val
 * @param  value
 * @param  minLength
 * @return
 */
var minLengthValidator = function minLengthValidator(value, minLength) {
  return value.length >= minLength;
};
/**
 * Check to confirm that feild is required
 *
 * @param value
 * @return
 */

var requiredValidator = function requiredValidator(value) {
  return value.trim() !== '';
};
/**
 * Email validation
 *
 * @param value
 * @return
 */

var emailValidator = function emailValidator(value) {
  // eslint-disable-next-line
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[\d]{1,3}\.[\d]{1,3}\.[\d]{1,3}\.[\d]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(value).toLowerCase());
};
var numberValidator = function numberValidator(value) {
  if (value) {
    var re = /(^[\d]+$|^$)/;
    return re.test(value);
  }
  return false;
};
var validateKosovoPostalCode = function validateKosovoPostalCode(value) {
  var kosovoPostalCodeRegex = /^([1-6][0-9]|7[0-3])\d{3}$/;
  return kosovoPostalCodeRegex.test(value);
};
var postalCodeValidator = function postalCodeValidator(value, countryCode, isPostalCodeOptional) {
  if (isPostalCodeOptional === void 0) {
    isPostalCodeOptional = false;
  }
  var status = true;
  var isRequired = true;
  if (isPostalCodeOptional && (0, _lodash.isEmpty)(value)) {
    isRequired = false;
  }
  if (!(0, _lodash.isEmpty)(countryCode) && isRequired) {
    if (countryCode === 'KV') {
      return validateKosovoPostalCode(value);
    }
    status = _postalCodesJs.default.validate(countryCode, value);
    status = (0, _lodash.isBoolean)(status) ? status : false;
    if (status) {
      // validate if string have double space and dash and space with dash at prefix and suffix
      var regex = /(\s){2}|(\-){2}|(\s)\-|(\-)\s/g;
      var specialCharStatus = regex.test(value);
      status = !specialCharStatus;
    }
  }
  return status;
};
var phoneNumberFormatValue = function phoneNumberFormatValue(value, countryCode) {
  if (!(0, _lodash.isEmpty)(countryCode) && !(0, _lodash.isEmpty)(value)) {
    var code = (0, _lodash.toUpper)(countryCode);
    var parseNumber = (0, _libphonenumberJs.default)(value, code);
    var _ref = parseNumber || {},
      _ref$number = _ref.number,
      number = _ref$number === void 0 ? value : _ref$number;
    var asYouType = new _libphonenumberJs.AsYouType(code);
    return asYouType.input(number);
  }
  return value;
};
exports.phoneNumberFormatValue = phoneNumberFormatValue;
var getCountryFromPhone = function getCountryFromPhone(value) {
  if (!(0, _lodash.isEmpty)(value)) {
    var parseNumber = (0, _libphonenumberJs.default)(value);
    var country = (0, _lodash.get)(parseNumber, 'country');
    return country;
  }
  return value;
};
exports.getCountryFromPhone = getCountryFromPhone;
var validateKosovoPhoneNum = function validateKosovoPhoneNum(value) {
  var kosovoPhoneRegex = /^\+383\s?\d{2}\s?\d{3}\s?\d{3}$/;
  return kosovoPhoneRegex.test(value);
};
var phoneNumberValidator = function phoneNumberValidator(value, countryCode) {
  var status = !(0, _lodash.isEmpty)(value);
  if (!(0, _lodash.isEmpty)(countryCode) && !(0, _lodash.isEmpty)(value)) {
    var code = (0, _lodash.toUpper)(countryCode);
    if (code === 'KV') {
      return validateKosovoPhoneNum(value);
    }
    status = (0, _libphonenumberJs.isValidPhoneNumber)(value, code);
    var parseNumber = (0, _libphonenumberJs.default)(value, code);
    var country = (0, _lodash.get)(parseNumber, 'country', code);
    if (country !== code) {
      status = false;
    }
  }
  return status;
};
var validator = function validator(value, rules, countryCode, isValidateOptional) {
  if (countryCode === void 0) {
    countryCode = '';
  }
  if (isValidateOptional === void 0) {
    isValidateOptional = false;
  }
  var isValid = true;
  Object.keys(rules).forEach(function (rule) {
    switch (rule) {
      case 'minLength':
        isValid = isValid && minLengthValidator(value, rules[rule]);
        break;
      case 'isRequired':
        isValid = rules[rule] ? isValid && requiredValidator(value) : true;
        break;
      case 'isEmail':
        isValid = isValid && emailValidator(value);
        break;
      case 'numbersOnly':
        isValid = isValid && numberValidator(value);
        break;
      case 'isPostalCode':
        isValid = isValid && postalCodeValidator(value, countryCode, isValidateOptional);
        break;
      case 'isPhoneNumber':
        isValid = isValid && phoneNumberValidator(value, countryCode);
        break;
      default:
        isValid = true;
    }
  });
  return isValid;
};
var _default = validator;
exports.default = _default;